<template>
  <div class="container">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.staytalk}} > <span>{{locale[talk]}}</span></h1>
        <div>
          <Card
            v-if="talk === 'card'"
            :locale="locale"
            :lang="lang"
            :card="card"
            @add="add"
            @del="delItems"
            @apply="applyItem" />
          <Tag
            v-if="talk === 'tag'"
            :locale="locale"
            :lang="lang"
            :tag="tag"
            :cardList="cardList"
            @add="add"
            @del="delItems"
            @apply="applyItem" />
          <Setting
            v-if="talk === 'setting'"
            :locale="locale"
            :lang="lang"
            :setting="setting"
            :cardList="cardList"
            :tagList="tagList"
            @apply="applySetting" />
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <div class="pageNav">
          <button type="button" class="mb15 btn btnFull toCapitalize" :class="{btnWhite: talk !== 'card'}" @click="setTalk('card')">{{locale.card}}</button>
          <button type="button" class="mb15 btn btnFull toCapitalize" :class="{btnWhite: talk !== 'tag'}" @click="setTalk('tag')">{{locale.tag}}</button>
          <button type="button" class="mb15 btn btnFull toCapitalize" :class="{btnWhite: talk !== 'setting'}" @click="setTalk('setting')">{{locale.setting}}</button>
        </div>
      </div></div>
    </section>
    <div id="setContent">
      <div class="innerItem">
        <button type="button" class="btn btnFull btnPrimary" @click="onSave">{{locale.save}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import Card from '@/components/Talk/Card'
import Tag from '@/components/Talk/Tag'
import Setting from '@/components/Talk/Setting'

export default {
  name: 'Talk',
  props: [
    'locale'
  ],
  components: {
    Card,
    Tag,
    Setting
  },
  computed: {
    ...mapGetters({
      settingData: 'setting/getData'
    }),
    lang () {
      return this.settingData.lang
    },
    cardList () {
      const lang = this.lang.default
      return this.card.list.map(x => {
        return {
          id: x.id,
          type: 'card',
          name: x.name,
          text: x.text,
          text2: x.text[lang],
          img: x.img
        }
      })
    },
    tagList () {
      const lang = this.lang.default
      const tags = this.tag.list.map(x => {
        return {
          id: x.id,
          type: 'card',
          name: x.name,
          tag: x.tag,
          tag2: x.tag[lang]
        }
      })
      return tags
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.track()
    }
  },
  created () {
    const params = this.$route.params.talk || 'card'
    this.talk = params
    this.init()
  },
  mounted () {
    if (this.$store.state.authentication.userInfo !== null) {
      this.track()
    }
  },
  data () {
    return {
      talk: 'card', // card, tag, setting
      card: {
        list: []
      },
      tag: {
        list: []
      },
      group: {
        list: []
      },
      setting: {
        title: LANG.valueObj('STAY Talk'),
        enterance: [],
        welcome: [],
        missed: [],
        senderIcon: '0',
        senderIconThumb: '',
        viewAvailableTime: false
      }
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.userInfo.siteid
      const routerPath = this.$route.path
      const talk = this.$route.params.talk
      const path = `${site}${routerPath}`
      const title = `talk - ${talk}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    init () {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('talk/getTalk').then((res) => {
        if (res) {
          this.card = { ...this.card, ...res.card }
          this.tag = { ...this.tag, ...res.tag }
          this.setting = { ...this.setting, ...res.setting }
        }
        this.$store.commit('onLoading', false)
      })
    },
    setTalk (talk) {
      this.talk = talk
      this.$router.replace({
        params: {
          talk: talk
        }
      })
    },
    add (data) {
      const target = data.target
      this[target].list.unshift(data.data)
    },
    delItems (data) {
      const target = data.target
      const ids = data.ids
      this[target].list = this[target].list.filter(x => !ids.includes(x.id))
    },
    applyItem (data) {
      const target = data.target
      this[target].list = this[target].list.map(x => {
        return x.id === data.id ? data.data : x
      })
    },
    applySetting (data) {
      const target = data.target
      this.setting[target] = data.data
    },
    onSave () {
      const data = {
        updated: new Date().toISOString(),
        card: this.card,
        tag: this.tag,
        setting: this.setting
      }
      this.$store.commit('onLoading', true)
      this.$store.dispatch('talk/setTalk', data)
        .then(res => {
          alert(this.locale.complete_save)
          this.init()
          this.$store.commit('onLoading', false)
        })
    }
  }
}
</script>
